import type { ExportPreview } from "../../types/exports";

interface Props {
  preview: ExportPreview | null;
  loading: boolean;
  adding: boolean;
  error: string | null;
  onAddAll: () => void;
  onRefresh: () => void;
}

export function CrossSellingNotice({
  preview,
  loading,
  adding,
  error,
  onAddAll,
  onRefresh,
}: Props) {
  return (
    <section
      className="rounded-lg border border-blue-200 bg-blue-50 p-4 dark:border-blue-800 dark:bg-gray-800"
      aria-labelledby="cross-selling-title"
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2
            id="cross-selling-title"
            className="font-semibold text-gray-900 dark:text-white"
          >
            Verkäufe außerhalb der ausgewählten Teams
          </h2>
          <p className="mt-1 text-sm text-gray-700 dark:text-gray-300">
            {loading
              ? "Passende Verträge werden geprüft …"
              : preview
              ? `${preview.missing_worker_count.toLocaleString(
                  "de-DE"
                )} weitere Mitarbeitende haben ${preview.missing_contracts.toLocaleString(
                  "de-DE"
                )} passende Verträge abgeschlossen.`
              : "Wählen Sie Zeitraum, Anbieter und Teams, um weitere Mitarbeitende zu prüfen."}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={onRefresh}
            disabled={loading || adding}
            className="rounded-lg border border-blue-300 px-3 py-2 text-sm text-blue-800 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 dark:border-blue-700 dark:text-blue-200 dark:hover:bg-blue-900"
          >
            Aktualisieren
          </button>
          <button
            type="button"
            onClick={onAddAll}
            disabled={
              !preview?.missing_worker_count || loading || adding || !!error
            }
            className="rounded-lg bg-blue-700 px-3 py-2 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
          >
            {adding
              ? "Wird hinzugefügt …"
              : "Fehlende Mitarbeitende hinzufügen"}
          </button>
        </div>
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-700 dark:text-red-300" role="alert">
          {error}
        </p>
      )}
      {preview && preview.missing_workers.length > 0 && (
        <details className="mt-3 text-sm text-gray-700 dark:text-gray-300">
          <summary className="cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500">
            Erste passende Mitarbeitende anzeigen
          </summary>
          <ul className="mt-2 list-inside list-disc space-y-1">
            {preview.missing_workers.slice(0, 10).map((worker) => (
              <li key={worker.id}>
                {worker.name} · {worker.contract_count.toLocaleString("de-DE")}{" "}
                Verträge
              </li>
            ))}
          </ul>
        </details>
      )}
      <p className="mt-2 text-xs text-gray-600 dark:text-gray-400">
        Das Hinzufügen ist freiwillig. Danach können Sie einzelne Personen in
        „Zusätzliche Mitarbeitende“ wieder abwählen. Teammitglieder bleiben über
        ihr Team eingeschlossen.
      </p>
    </section>
  );
}
